import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComboChart = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.1553 12.7929H12.272C12.6711 12.7929 12.9927 13.0152 12.9927 13.2782V20.0968H14.3528V15.5824C14.3528 15.317 14.6707 15.0969 15.0735 15.0969H15.1903C15.5931 15.0969 15.911 15.317 15.911 15.5824V20.0968H21.3294C22.2235 20.0968 22.2235 21 21.3294 21H2.67992C2.30466 21 2 20.7977 2 20.5484V20.3349V6.45158C2 6.20235 2.30452 6 2.67992 6C3.05518 6 3.35985 6.20225 3.35985 6.45158V20.097H5.59865V9.10095C5.59865 8.83561 5.91657 8.61546 6.31939 8.61546H6.43613C6.83895 8.61546 7.15686 8.83561 7.15686 9.10095V20.097H8.51691V10.7287C8.51691 10.4634 8.83483 10.2432 9.23765 10.2432H9.35439C9.75722 10.2432 10.0751 10.4634 10.0751 10.7287V20.097H11.435V13.272C11.4399 13.0116 11.7603 12.7929 12.1553 12.7929Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.5 1.75C3.5 1.33579 3.16421 1 2.75 1C2.33579 1 2 1.33579 2 1.75V20.25C2 20.6642 2.33579 21 2.75 21H21C21.4142 21 21.75 20.6642 21.75 20.25C21.75 19.8358 21.4142 19.5 21 19.5H3.5V1.75Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.7657 4.94759C21.0761 4.76462 21.1794 4.36462 20.9965 4.05417C20.8135 3.74372 20.4135 3.64039 20.103 3.82336L14.0406 7.39656L11.7168 3.45395C11.5338 3.1435 11.1338 3.04016 10.8234 3.22314L4.46375 6.97147C4.15331 7.15444 4.04997 7.55444 4.23295 7.86489C4.41592 8.17534 4.81592 8.27868 5.12637 8.0957L10.9239 4.67868L13.2476 8.62129C13.4306 8.93174 13.8306 9.03508 14.1411 8.8521L20.7657 4.94759Z",
			fill: "var(--colors-grey-1)"
		})
	]
});
export default SvgComboChart;
